import React from "react";
import "./Features.css";
import details from "./Feature-details";
// console.log(details);
const Features = () => {
  return (
    <div>
      <div className="features" id="features">
        <div className="container">
          <h6>Vendora-Features</h6>
          <h1>Digitize Vendor Workflows from Onboarding to Payment</h1>
          <div className="features-section">
            
              <div className="row" >
              {details.map((elem) => {
              const { id, icon, title, content } = elem;
              return ( 
                <div className="col-md-4 col-xl-3" key={id}>
                  <div className="features-container">
                    <div className="feature-icon">
                      <div className="feature-img">
                      <img 
  src={process.env.PUBLIC_URL + icon} 
  alt={title}
/>
                    </div>
                    </div>
                    <div className="feature-content">
                      <h5>{title}</h5>
                      <p>
                        {content}
                      </p>
                    </div>
                  </div>
                </div>
                    );
                })}
              </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
